import React from 'react';
import './ModalInfo.css'
import succesOk from '../../../images/succesOk.svg'
import succesError from '../../../images/succesErr.svg'

export function ModalInfo (props) {
  const succesIcon = props.icon ? succesOk : succesError
    
   return (
     <div className={`modal__info-overlay  modal_type_${props.name} ${props.isAnimating ? 'closing' : ''}`} onClick={props.toggleModal}>
       <div className={`modal__container modal__container__type_${props.name}`} onClick={e => e.stopPropagation()}>   
         <button onClick={props.onClose} type="button" className="modal__close" aria-label="Закрыть форму"></button>
         <img className="modal__icon" src={succesIcon} alt="иконка подтверждения" />
         <div className='modal__text'>
           <h2 className="modal__title_modal-info font20Norm">{props.textError}</h2>
           {props.children}
         </div>
       </div>
     </div>
  
   )
 }